import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = {
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 200 200",
  style: {"width":"100%","height":"100%"}
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  d: "M70.7 113.4c-.7 1.9-1 4-1 6.1v19.6c0 2.6.5 5.1 1.5 7.5 1 2.4 2.5 4.5 4.4 6.4 1.9 1.8 4.1 3.3 6.5 4.2 2.4 1 5.1 1.5 7.7 1.5H110c2.6 0 5.3-.5 7.7-1.5 2.4-1 4.7-2.4 6.5-4.2 1.9-1.8 3.4-4 4.4-6.4 1-2.4 1.5-4.9 1.5-7.5v-19.6c0-2.2-.4-4.2-1-6.2 30.1 7.8 51.4 27.4 51.4 50.2v14.7c0 2.6-.5 5.1-1.5 7.5-1 2.4-2.5 4.5-4.4 6.4-1.9 1.8-4.1 3.3-6.5 4.2-2.4 1-5.1 1.5-7.7 1.5H39.5c-2.6 0-5.3-.5-7.7-1.5-2.4-1-4.7-2.4-6.5-4.2-1.9-1.8-3.4-4-4.4-6.4-1-2.4-1.5-4.9-1.5-7.5v-14.7c-.1-22.7 21.2-42.3 51.3-50.1zm29.3 6.2c2.7 0 5.2 1 7.1 2.9 1.9 1.8 3 4.3 3 6.9v9.8c0 1.3-.3 2.6-.8 3.8-.5 1.2-1.2 2.3-2.2 3.2-.9.9-2.1 1.6-3.3 2.1-1.2.5-2.5.8-3.9.8s-2.6-.3-3.9-.8c-1.2-.5-2.3-1.2-3.3-2.1-.9-.9-1.7-2-2.2-3.2-.5-1.2-.8-2.5-.8-3.8v-9.8c0-2.6 1.1-5.1 3-6.9 2.1-1.9 4.6-2.9 7.3-2.9zm0-9.8c-27.9 0-50.4-24.1-50.4-53.9C49.6 26.1 72.1 2 100 2s50.4 24.1 50.4 53.9c0 29.7-22.5 53.9-50.4 53.9z"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("span", {
    class: "tri-icon",
    style: _normalizeStyle(`font-size: ${_ctx.size}; color: ${_ctx.color}; width: 1em; height: 1em; display:block; line-height: 0;`)
  }, [
    (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
  ], 4))
}